import Vue from "vue";
import VueHighlightJS from "vue-highlight.js";

//import 'highlight.js/styles/default.css';
import "highlight.js/styles/tomorrow-night-blue.css";

// Tell Vue.js to use vue-highlightjs
Vue.use(VueHighlightJS);
